export const OPERATOR_PASSWORD_MIN_LENGTH = 8;
export const OPERATOR_PASSWORD_MAX_LENGTH = 128;

export function isOperatorPasswordValid(password: string): boolean {
  return (
    password.length >= OPERATOR_PASSWORD_MIN_LENGTH &&
    password.length <= OPERATOR_PASSWORD_MAX_LENGTH
  );
}
